import { useMemo } from 'react'

//* Components
import { DebateWindow } from 'components/common'

//* Style
import DebateStyle from './style'

const Debates = ({ debates }) => {
    const storeDebates = useMemo(() => {
        return debates?.map((i, k) => (
            <DebateWindow debate={i} />
        ))
    }, [debates])

    return (
        <DebateStyle className='flexBoxWrap alignStart dbs'>
            {storeDebates}
        </DebateStyle>
    )
}

export default Debates
